export default "__VITE_ASSET__bdc2832d__"